export interface ISelfRating {
  id: string | undefined,
  managerType: String | undefined,
  prelimApplicationId: Number | undefined,
  q1: string | undefined,
  q2: string | undefined,
  q3: string | undefined,
  q4: string | undefined,
  q5: string | undefined,
  q6: string | undefined,
  q7: string | undefined,
  q8: string | undefined,
  q9: string | undefined,
  q10: string | undefined,
  q11: string | undefined,
  q12: string | undefined,
  q13: string | undefined,
  q14: string | undefined,
  q15: string | undefined,
  q16: string | undefined,
  q17: string | undefined,
  fundType: string | undefined,
  q1Comments: string | undefined,
  q2Comments: string | undefined,
  q3Comments: string | undefined,
  q4Comments: string | undefined,
  q5Comments: string | undefined,
  q6Comments: string | undefined,
  q7Comments: string | undefined,
  q8Comments: string | undefined,
  q9Comments: string | undefined,
  q10Comments: string | undefined,
  q11Comments: string | undefined,
  q12Comments: string | undefined,
  q13Comments: string | undefined,
  q14Comments: string | undefined,
  q15Comments: string | undefined,
  q16Comments: string | undefined,
  q17Comments: string | undefined,
  score: string | undefined,
}

export const defaultIISelfRating = {
  id: undefined,
  managerType: "Experienced Fund Manager",
  prelimApplicationId: undefined,
  q1: undefined,
  q2: undefined,
  q3: undefined,
  q4: undefined,
  q5: undefined,
  q6: undefined,
  q7: undefined,
  q8: undefined,
  q9: undefined,
  q10: undefined,
  q11: undefined,
  q12: undefined,
  q13: undefined,
  q14: undefined,
  q15: undefined,
  q16: undefined,
  q17: undefined,
  fundType: "Equity Oriented Fund",
  q1Comments: undefined,
  q2Comments: undefined,
  q3Comments: undefined,
  q4Comments: undefined,
  q5Comments: undefined,
  q6Comments: undefined,
  q7Comments: undefined,
  q8Comments: undefined,
  q9Comments: undefined,
  q10Comments: undefined,
  q11Comments: undefined,
  q12Comments: undefined,
  q13Comments: undefined,
  q14Comments: undefined,
  q15Comments: undefined,
  q16Comments: undefined,
  q17Comments: undefined,
  score: undefined,
}